import {useEffect} from 'react'
import getDeviceId from '@helpers/auth/getDeviceId'
import {useApolloQuery} from '@packages/apollo-hooks'
import {configureScope} from '@sentry/minimal'
import gql from 'graphql-tag'

import getEnv from '../getEnv'

export default function SentryUserProvider(props) {
  const {me} = useApolloQuery({
    query: gql`
      query getEmail {
        me {
          _id
          email
        }
      }
    `
  })

  useEffect(() => {
    if (getEnv() !== 'prod') return null
    configureScope(scope => {
      scope.clear()
      scope.setTag('deviceId', getDeviceId())

      if (me) {
        scope.setUser({id: me._id, email: me.email})
      }
    })
  }, [me, me?._id])

  return null
}
